import { nifsAxios } from 'constants/axios';

export default async function (userId: string, liveFeedId: string) {
  const response = await nifsAxios.get(`/liveFeeds/${liveFeedId}?userId=${userId}`);
  return response.data;
}
